import { useEffect, useRef } from "react";
import $ from "jquery";

/**
 * YearPickerInput (jQuery wrapper)
 * Props:
 *  - value: string|number (e.g. "2024" or 2024)
 *  - onChange: (year: string|number) => void
 *  - startYear, endYear: numbers
 *  - placeholder: string
 */
export default function YearPickerInput({
    value,
    onChange,
    startYear = new Date().getFullYear() - 10,
    endYear = new Date().getFullYear() + 1,
    placeholder = "Select year",
    className = "form-control yearpicker",
    ...rest
}) {
    const inputRef = useRef(null);
    const $elRef = useRef(null);


    useEffect(() => {
        const $el = $(inputRef.current);
        $elRef.current = $el;

        $el.yearpicker?.({
            startYear,
            endYear,
            year: value ? Number(value) : undefined,
            onChange: (val) => onChange?.(val),
        });

        return () => {
            try { $el.yearpicker?.("destroy"); } catch { }
        };
    }, [startYear, endYear]);


    
    // init once
    // useEffect(() => {
    //     const $el = $(inputRef.current);
    //     $elRef.current = $el;

    //     // initialize plugin
    //     $el.yearpicker?.({
    //         startYear,
    //         endYear,
    //         // some yearpickers accept 'year' as initial value
    //         year: value ? Number(value) : undefined,
    //         // some yearpickers expose an onChange callback option
    //         onChange: (val) => {
    //             if (onChange) onChange(val);
    //         },
    //     });

    //     // wire up event names commonly used by yearpicker plugins
    //     const dispatch = () => {
    //         const val = $el.val();
    //         if (onChange) onChange(val);
    //     };

    //     // common event names we might see
    //     $el.on("change", dispatch);
    //     $el.on("yearSelected", (_e, year) => onChange?.(year));
    //     $el.on("changeYear", (_e) => dispatch());

    //     return () => {
    //         // cleanup listeners & destroy plugin
    //         $el.off("change", dispatch);
    //         $el.off("yearSelected");
    //         $el.off("changeYear");
    //         try {
    //             $el.yearpicker?.("destroy");
    //         } catch (_) {
    //             // some plugins don’t support destroy; ignore
    //         }
    //     };
    //     // init deps only (don’t re-init on value changes)
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [startYear, endYear]);



    // keep widget in sync when `value` prop changes from outside
    // useEffect(() => {
    //     const $el = $elRef.current;
    //     if (!$el) return;

    //     const str = value == null ? "" : String(value);
    //     if ($el.val() !== str) {
    //         $el.val(str);
    //         // some plugins offer a setter
    //         try {
    //             $el.yearpicker?.("setValue", str);
    //         } catch (_) { }
    //     }
    // }, [value]);

    return (
        <input
            ref={inputRef}
            type="text"
            className={className}
            placeholder={placeholder}
            readOnly // most yearpickers manage the value; avoids React warnings
            {...rest}
        />
    );
}